var _circle, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRelatedPersonsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17.25,
    r: 2.25,
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 25V24.25C10 23.0074 11.0074 22 12.25 22H15.75C16.9926 22 18 23.0074 18 24.25V25",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 14,
    height: 14,
    rx: 3,
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11V10C10 8.34315 11.3431 7 13 7H22C23.6569 7 25 8.34315 25 10V19C25 20.6569 23.6569 22 22 22H21",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRelatedPersonsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RelatedPersonsIcon.db2e9f29.svg";
export { ForwardRef as ReactComponent };